module.exports = __webpack_public_path__ + "img/gx_company.485f234d.png";